import { Spinner } from '@frontend/components/common';
import { ICONS, QRCode } from '@frontend/icons';
import { CommonMessage } from '@frontend/lang';
import { LuCheck } from 'react-icons/lu';
import { FormattedMessage } from 'react-intl';

import WizardScreenContainer from '../../components/wizard-screen-container/wizard-screen-container.component';
import usePickUpScanQrCode from './pick-up-scan-qr-code.controller';

const ID = 'pick-up-scan-qr-code';

const PickUpScanQrCode = () => {
    const viewProps = usePickUpScanQrCode();

    return (
        <WizardScreenContainer
            id={ID}
            header={{ title: CommonMessage.BUTTONS.PICK_UP }}
            footer={{
                onSubmit: viewProps.onSubmit,
                submitDisabled: viewProps.submitDisabled
            }}
            loadingModal={{ show: viewProps.resolving }}
            errorModal={{
                show: !!viewProps.error,
                title: CommonMessage.ERRORS.UNRECOGNIZED_CODE,
                message: viewProps.error,
                onClose: viewProps.resetError
            }}
            containerClassName='bg-background-default flex flex-1 flex-col items-center justify-start gap-8 self-stretch overflow-y-scroll p-6 pb-20'>
            {/* Header with QR icon */}
            <div className='inline-flex items-center justify-center gap-3 self-stretch'>
                <div className='relative size-6 overflow-hidden'>
                    <QRCode className='text-always-black size-6' />
                </div>
                <div className='text-always-black justify-end text-lg font-medium'>
                    <FormattedMessage
                        id='kiosk.wizard.pick-up-scan-qr-code.scan-qr-code'
                        defaultMessage='Scan QR-code'
                        description='Label for QR code scanning'
                    />
                </div>
            </div>

            {/* Spacer */}
            <div className='h-8 w-full' />

            {/* Instructions */}
            <div className='flex flex-col items-center gap-5'>
                <div className='text-always-black justify-end text-center text-base font-medium'>
                    <FormattedMessage
                        id='kiosk.wizard.pick-up-scan-qr-code.instructions'
                        defaultMessage='Use the scanner below to scan your QR-code'
                        description='Instructions for scanning QR code'
                    />
                </div>

                {/* Arrow pointing down */}
                <div
                    className={`${!viewProps.submitDisabled ? 'bg-status-success' : 'bg-brand-secondary'} flex size-24 items-center justify-center rounded-full`}>
                    {!viewProps.submitDisabled ? (
                        <LuCheck className='text-always-white size-16' />
                    ) : (
                        <>
                            {viewProps.resolving && <Spinner className='text-border-default fill-brand-primary size-25' />}
                            <ICONS.BUTTON.ARROW_DOWN className='text-always-white absolute size-10' />
                        </>
                    )}
                </div>
            </div>
        </WizardScreenContainer>
    );
};

export default PickUpScanQrCode;
